import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Helmet } from 'react-helmet';
import { ContextPageData } from '../../context/PageData/index.js';
export const StripeScriptLoader = () => {
    const { viewer } = React.useContext(ContextPageData);
    // stripe loaded on every page to detect fraud
    // only load stripe when the user is logged in for better SEO
    // stripe's JS file takes about 1s on the main thread to execute
    return viewer ? (_jsx(Helmet, { children: _jsx("script", { src: "https://js.stripe.com/v3", type: "text/javascript" }) })) : null;
};
//# sourceMappingURL=index.js.map